"use client";

import { useEffect, useState } from "react";

import { useCcPrefersReducedMotion } from "@/lib/use-cc-prefers-reduced-motion";

type CcLsTickerProps = {
  label: string;
  items: string[];
};

/** Rotating local wins in a glass pill (lassie.ai). Reduced motion keeps the first one. */
export function CcLsTicker({ label, items }: CcLsTickerProps) {
  const reduced = useCcPrefersReducedMotion();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (reduced || items.length < 2) return;
    const timer = window.setInterval(
      () => setIndex((value) => (value + 1) % items.length),
      2800,
    );
    return () => window.clearInterval(timer);
  }, [reduced, items.length]);

  return (
    <div className="cc-ls-ticker">
      <span className="cc-ls-ticker__live" aria-hidden="true" />
      <span className="cc-ls-ticker__label">{label}</span>
      <span className="cc-ls-ticker__window">
        {items.map((item, i) => (
          <span
            key={item}
            className="cc-ls-ticker__item"
            data-state={
              i === index
                ? "on"
                : i === (index - 1 + items.length) % items.length
                  ? "off"
                  : undefined
            }
            aria-hidden={i === index ? undefined : true}
          >
            {item}
          </span>
        ))}
      </span>
    </div>
  );
}
